import { MediaDownloadDto, SlideDownloadDto, SlideTemplateDownloadDto } from 'collaboration-service';
import ContentComparisonSlider from 'components/ContentComparisonSlider/ContentComparisonSlider';
import { dummyBG1 } from 'components/Posts/StandardPost';
import SafeHTML from 'components/SafeHTML/SafeHTML';
import { Image } from 'imaginarity-react-ui';
import _ from 'lodash';
import * as React from 'react';
import { getContentNodeBySlidePart } from 'services/Helpers';
import { getMediaLink } from 'services/Helpers/MediaHelpers';
import { getTranslated } from 'services/Helpers/TranslationHelpers';
import WikiHotSpot from 'views/Wiki/WikiHotSpot';
import { SlideViewMode } from './SlideShowContent';
import { SlideshowSC as T } from './SlideshowSC';

interface SlideProps {
    lng: string;
    height?: number;
    slide?: SlideDownloadDto;
    template?: SlideTemplateDownloadDto;
    masterBackgroundImage?: MediaDownloadDto;
    viewMode: SlideViewMode;
    preview?: boolean;
    allowPointerEvents?: boolean;
}

const Slide = (p: SlideProps) => {
    const { slide, lng, allowPointerEvents } = p;
    return (
        <T.Container parts={slide?.parts.length ?? 1} style={{ position: "relative" }}>
            {_.map(slide?.parts, (part, idx) => {
                if (!part || (part.useMedia && !part.media)) {
                    return (<div key={idx} />);
                }
                const overlay = getTranslated(part.mediaOverlay, lng);
                const src = getMediaLink(part, p => p.media) ?? dummyBG1;
                return (
                    <T.GridColumn key={idx}>
                        {part.partType === 'Compare' &&
                            <div>
                                <ContentComparisonSlider
                                    contentOne={getContentNodeBySlidePart(part)}
                                    contentTwo={getContentNodeBySlidePart(part.subPart)}
                                    aspectRatio={16 / 9}
                                    allowSlideByMouseOver={false}
                                    allowSlideByGrab
                                    allowPointerEvents={allowPointerEvents}
                                    noContextMenu={true}
                                />
                            </div>
                        }
                        {part.useMedia && part.partType !== 'Compare' &&
                            <T.GridColumnPosition vAlign={part.verticalAlignment}>
                                <>
                                    {part.media.mediaType.startsWith('video') &&
                                        <video
                                            controlsList="nodownload"
                                            controls
                                            playsInline
                                            crossOrigin="anonymous"
                                            src={src}
                                            width='100%'
                                        />
                                    }
                                    {part.media.mediaType.startsWith('audio') &&
                                        <audio
                                            controlsList="nodownload"
                                            controls
                                            preload="metadata"
                                            crossOrigin="anonymous"
                                            src={src}
                                            style={{ width: "100%", outline: "none" }}
                                        />
                                    }
                                    {part.media.mediaType.startsWith('image') &&
                                        <>
                                            <Image src={src} />
                                            <T.HotSpot>
                                                {overlay &&
                                                    _.map(overlay.elements, (e, i) => {
                                                        const delay = (i + 1) * 0.5;
                                                        return (
                                                            <WikiHotSpot
                                                                key={i}
                                                                element={e}
                                                                mediaOverlay={part.mediaOverlay}
                                                                index={i}
                                                                delay={delay}
                                                                imgWidth={400}
                                                                imgHeight={280}
                                                                width={100}
                                                                offsetY={0}
                                                            />
                                                        );
                                                    })
                                                }
                                            </T.HotSpot>
                                        </>
                                    }
                                </>
                            </T.GridColumnPosition>
                        }
                        {part.text && !part.useMedia && part.partType !== 'Compare' &&
                            <T.GridColumnPosition vAlign={part.verticalAlignment} hAlign={part.horizontalAlignment} style={{ padding: 10 }}>
                                <SafeHTML html={part.text} />
                            </T.GridColumnPosition>
                        }
                    </T.GridColumn>
                );
            })}
        </T.Container >
    );
}
export default Slide;